/**
 * Semantic Color Tokens — use these in components.
 * Maps design intent to CSS custom properties.
 */

export const text = {
  primary: "var(--sem-text-primary)",
  secondary: "var(--sem-text-secondary)",
  muted: "var(--sem-text-muted)",
  disabled: "var(--sem-text-disabled)",
  onDark: "var(--sem-text-onDark)",
  link: "var(--sem-text-link)",
  content: "var(--sem-text-content)",
} as const;

export const surface = {
  page: "var(--sem-surface-page)",
  raised: "var(--sem-surface-raised)",
  muted: "var(--sem-surface-muted)",
  panel: "var(--sem-surface-panel)",
  controls: "var(--sem-surface-controls)",
  input: "var(--sem-surface-input)",
  white: "var(--sem-surface-white)",
  overlay: "var(--sem-surface-overlay)",
  subtle: "var(--sem-surface-subtle)",
  subtleHover: "var(--sem-surface-subtleHover)",
  highlight: "var(--sem-surface-highlight)",
  selected: "var(--sem-surface-selected)",
  hover: "var(--sem-surface-hover)",
  disabled: "var(--sem-surface-disabled)",
} as const;

export const border = {
  default: "var(--sem-border-default)",
  subtle: "var(--sem-border-subtle)",
  strong: "var(--sem-border-strong)",
  divider: "var(--sem-border-divider)",
  control: "var(--sem-border-control)",
  focus: "var(--sem-border-focus)",
} as const;

export const interactive = {
  default: "var(--sem-interactive-default)",
  hover: "var(--sem-interactive-hover)",
  muted: "var(--sem-interactive-muted)",
} as const;

export const status = {
  success: "var(--sem-status-success)",
  error: "var(--sem-status-error)",
  errorDark: "var(--sem-status-errorDark)",
  gold: "var(--sem-status-gold)",
  goldHover: "var(--sem-status-goldHover)",
} as const;

export const brand = {
  dark: "var(--sem-brand-dark)",
  light: "var(--sem-brand-light)",
  accent: "var(--sem-brand-accent)",
} as const;

export const nav = {
  background: "var(--sem-nav-background)",
  surface: "var(--sem-nav-surface)",
  secondary: "var(--sem-nav-secondary)",
  hover: "var(--sem-nav-hover)",
} as const;

export const footer = {
  bg: "var(--sem-footer-bg)",
} as const;
